import ApiService from '@/services/api.service';
import getters from '@/store/global';
import getUniqBy from '@/mixins/getUniqBy';

const state = {
    threads: [],
    count: '',
    next: '',
    search: {},
    newThread: {},
    errors: {}
};

getters['fetchThreads'] = function(state) { return state.threads }
getters['fetchThreadById'] = (state) => (id) => {
    if (state.threads.results) {
        return state.threads.results.find(thread => thread.id === id)
    }
    return {}    
}
getters['fetchSearch'] = function(state) { return state.search }
getters['fetchThreadsNext'] = function(state) { return state.next }
getters['fetchNewThread'] = function(state) { return state.newThread }

const actions = {
    getThreads(context) {
        return ApiService
            .get('messages/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_THREADS', response.data.results);
                context.commit('SET_COUNT', response.data.count);
                context.commit('SET_NEXT', response.data);
            })
            .catch(() => {
                throw new Error('Something goes wrong');
            });
    },
    getNext(context) {
        return ApiService
            .get(context.state.next)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('ADD_THREADS', response.data.results);
                context.commit('SET_NEXT', response.data);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    createThread(context, payload) {
        return ApiService
            .post('messages/create_thread/', payload.data)
            .then((response) => {
                context.commit('SET_ERROR', {});
                if (payload.add) {
                    context.commit('ADD_THREAD', response.data);
                } else {
                    context.commit('CHECK_THREAD', response.data);
                }
                
            })
            .catch((response) => {
                if (response.status == 400) {
                    throw new Error('Something goes wrong');
                }
            });
    },
    deleteThread(context, payload) {
        return ApiService
            .delete('messages/delete_thread/' + payload + '/')
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('REMOVE_THREAD', payload);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    editThread(context, payload) {
        return ApiService
            .put('messages/thread/' + payload.id + '/edit/', payload.data)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('EDIT_THREAD', [payload.id, response.data]);
            })
            .catch((response) => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    search(context, payload) {
        return ApiService
            .get('messages/search/?q=' + payload)
            .then((response) => {
                context.commit('SET_ERROR', {});
                context.commit('SET_SEARCH', response.data)
            })
            .catch(() => {
                context.commit('SET_ERROR', response.data);
                throw new Error('Something goes wrong');
            });
    },
    setNewMessages(context, payload) {
        context.commit('SET_NEW_MESSAGES', payload);
    },
    addThreadFromFront(context, payload) {
        context.commit('SET_FROM_FRONT', payload);
    }
};

const mutations = {
    SET_THREADS(state, threads) {    
        state.threads = threads;
        state.errors = {};
    },
    ADD_THREADS(state, threads) {
        // let array = state.threads.concat(threads);
        state.threads = getUniqBy(state.threads.concat(threads), 'id');
    },
    ADD_THREAD(state, thread) {
        state.threads.unshift(thread);
    },
    REMOVE_THREAD(state, thread) {
        for (let i in state.threads) {
            if (state.threads[i].id == thread) {
                state.threads.splice(i, 1);
            }
        }
    },
    SET_FROM_FRONT(state, data) {
        let thread = {};
        thread.id = data.thead;

    },
    CHECK_THREAD(state, thread) {
        let exists = false;
        for (let i in state.threads) {
            if (state.threads[i].id == thread.id) {
                exists = true;
                break;
            }
        }
        if (!exists) {
            state.threads.unshift(thread);
        }
        state.newThread = thread;
    },
    EDIT_THREAD(state, [id, thread]) {
        for (let k in state.threads) {
            if (state.threads[k].id == id) {
                state.threads[k] = thread;
            }
        }
    },
    SET_COUNT(state, count) {
        state.count = count;
        state.errors = {};
    },
    SET_NEXT(state, data) {
        if (data.page < data.num_pages) {
            state.next =
            data.url +
            '?' +
            data.page_param +
            '=' +
            (data.page + 1);
        } else {
            state.next = '';
        }
        state.errors = {};
    },
    SET_SEARCH(state, search) {
        state.search = search;
    },
    SET_NEW_MESSAGES(state, newMessages) {
        for (let i in state.threads) {
            if (state.threads[i].id == newMessages.id) {
                if (newMessages.count || newMessages.count == 0) {
                    if (newMessages.increment) {
                        state.threads[i].new_messages_count += newMessages.count;
                    } else {
                        state.threads[i].new_messages_count = newMessages.count;
                    } 
                }

                if (newMessages.text) {
                    if (!state.threads[i].last_message) {
                        state.threads[i].last_message = {};
                        state.threads[i].last_message.sender = {};
                    }
                    state.threads[i]
                    .last_message.sender.id = newMessages.senderId;
                    state.threads[i]
                    .last_message.text = newMessages.text;
                    state.threads[i]
                    .last_message.time = Math.floor(+new Date()/1000);
                }
                return;
            }
        }
        newMessages.thread.new_messages_count++;
        state.threads.unshift(newMessages.thread);
    },
    SET_ERROR(state, errors) {
        state.errors = errors;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
